import { render } from "./CouponAd.vue?vue&type=template&id=6118c6a6&scoped=true"
import script from "./CouponAd.vue?vue&type=script&lang=js"
export * from "./CouponAd.vue?vue&type=script&lang=js"

import "./CouponAd.vue?vue&type=style&index=0&id=6118c6a6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zxr_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6118c6a6"]])

export default __exports__